/**
 * GL10 입고작업조회 2.0 화면 메뉴코드. 1.0 GL10 은 그대로 두고 새 코드로 나란히 올린다(LOGISPRD-16038).
 * 감사로그 MENU_CD(X-Menu-Code)와 라우트 경로 끝이 이 값이다. moms-be 메뉴코드 상수와 같아야 한다.
 */
export const INBOUND_WORK_SEARCH_MENU_CODE = 'GL18'

/** 1.0 메타(prod MOMS_PROG_INFO MENU_CD=GL10)에 있는 화주 */
export const INBOUND_WORK_SEARCH_SHIPPERS = ['MUSINSA', 'MUSINSAGLOBAL', 'NIKE', 'NIKESAMPLE'] as const

/** 마감일자 기본값이 당일인 화주(1.0 systemTask.py:136). 그 밖의 화주는 DEFAULT_PERIOD_DAYS_OTHER_SHIPPER 일 전부터 */
export const DEFAULT_TODAY_SHIPPER = 'MUSINSA'

/** 마감일자 기본 기간 — 1.0 systemTask.py:136. MUSINSA 는 당일, 그 밖의 화주는 7일 전부터 */
export const DEFAULT_PERIOD_DAYS_OTHER_SHIPPER = 7

/** 조회 기간 상한(양끝 포함 일수). moms-be 가 넘으면 400 으로 거절한다 — 화면에서 먼저 막는다. page.schema.json gl18ClsDate 의 maxRangeDays(달력 범위 제한)와 같아야 한다. */
export const MAX_PERIOD_DAYS = 31

/** 입고송장번호 조회 목록 상한. moms-be 가 넘으면 400 으로 거절한다. page.schema.json gl18InvoiceNo 의 limit(입력 칸 카운터)과 같아야 한다. */
export const MAX_INVOICE_NOS = 1000

/** 엑셀 다운로드 행 상한 — 1.0 ToolBar.js 의 5만 건 차단과 같다. */
export const MAX_EXPORT_ROWS = 50000

/** 엑셀 다운로드 상세사유 최소 글자 수. page.schema.json gl18DownloadModal 의 minLength 와 같아야 한다(스키마를 바꾸면 여기도). 같은 규칙: rgr02V2/rules.ts REASON_DETAIL_MIN_LENGTH */
export const REASON_DETAIL_MIN_LENGTH = 5

/** 1.0 RenderUtil.onFormatDateByDate 의 요일 표기 */
export const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'] as const
